import { C } from "../../lib/constants";

export const Field = ({label, value, onChange, placeholder="", type="text"}) => (
  <div>
    <div style={{color:C.sub,fontSize:11,fontWeight:800,letterSpacing:0.8,textTransform:"uppercase",marginBottom:7}}>
      {label}
    </div>
    <input
      type={type}
      value={value}
      onChange={e=>onChange(e.target.value)}
      placeholder={placeholder}
      style={{width:"100%",background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 14px",fontSize:13,color:C.text,outline:"none"}}
    />
  </div>
);
